import { DateService } from '@/coreDomainsModule/services/dateService';
import { BulkPostOrderRequest, PostOrderRequestInfo } from '@/coreInfrastructureModule/axios/generated/orderManage';
import { DisplayIArrival } from '@/recommendOrderModule/pages/interfaces/displayIArrival';
import { IOrderBasisAdjustment } from '@/coreDomainsModule/entities/orderBasis';
import { OrderBasisUserAdjustedAdapter } from '@/coreUseCasesModule/orderBasis/adapters/OrderBasisUserAdjustedAdapter';

/**
 * UI用の型をAPIリクエストの型に変換する
 */
export class upsertOrderAdapter {
  /**
   * フロント側の発注情報の型、IAnnounceからBulkPostOrderResponseInfoに変換を行う
   * FIXME: Listに対してadaptするのやめてほしい（単体でやりたい）
   * @param registerOrderInfo - 登録を行う発注情報
   * @param aggregateBusinessId - 集計ID
   * @param orderBasisAdjustment - 発注根拠情報
   */
  public static adapt = (
    registerOrderInfo: DisplayIArrival[],
    aggregateBusinessId: string,
    orderBasisAdjustment: IOrderBasisAdjustment
  ): BulkPostOrderRequest => {
    const adaptedOrderInfo = registerOrderInfo.map((order: DisplayIArrival): PostOrderRequestInfo => {
      // 希望納期&納期
      const crossDate = order.crossDate ? DateService.convertIDateToDate(order.crossDate) : new Date();
      return {
        orderId: order.arrivalId,
        displayId: order.displayId,
        aggregateBusinessId: aggregateBusinessId,
        desiredDeliveryDate: DateService.formatDateToISOString(crossDate), // 希望納期
        estimatedTimeOfArrival: DateService.formatDateToISOString(crossDate), // 納期
        orderAmount: order.amount,
        orderStatus: order.status ? order.status : 'Recommended',
        orderNote: order.memoText,
        updateAt: order.updateAt,
      };
    });
    return {
      bulkPostOrderInfo: adaptedOrderInfo,
      orderBasisAdjustments: [{ aggregateBusinessId, adjustment: OrderBasisUserAdjustedAdapter.adapt(orderBasisAdjustment) }],
    };
  };
}
